import { FC, useEffect } from "react";
import Header from "../components/Header";
import { useAuthState } from "react-firebase-hooks/auth"
import TextInput from "../components/TextInput";
import TaskView from "../components/TaskView";
import { auth } from "../firebase";

const MainPage: FC = () => {
    const [user] = useAuthState(auth)
    let savedTasks: any
    useEffect(() => {
        savedTasks = localStorage.getItem("savedLinks")
    }, [])

    return (
        <main>
            <article>
                <Header user={user}/>
                <TextInput user={user}/>
                <TaskView user={user}/>
            </article>
        </main>
    );
}
 
export default MainPage;